/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as AppAdminRouteImport } from './routes/_app.admin'
import { Route as AppHomeRouteImport } from './routes/_app.home'
import { Route as AppWaiverRouteImport } from './routes/_app.waiver'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AppPlayersAthleteIdRouteImport } from './routes/_app.players.$athleteId'
import { Route as AppPlayersNewRouteImport } from './routes/_app.players.new'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppHomeRoute = AppHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AppRoute,
} as any)
const AppWaiverRoute = AppWaiverRouteImport.update({
  id: '/waiver',
  path: '/waiver',
  getParentRoute: () => AppRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AppPlayersAthleteIdRoute = AppPlayersAthleteIdRouteImport.update({
  id: '/players/$athleteId',
  path: '/players/$athleteId',
  getParentRoute: () => AppRoute,
} as any)
const AppPlayersNewRoute = AppPlayersNewRouteImport.update({
  id: '/players/new',
  path: '/players/new',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/verify-email': typeof VerifyEmailRoute
  '/admin': typeof AppAdminRoute
  '/home': typeof AppHomeRoute
  '/waiver': typeof AppWaiverRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/players/$athleteId': typeof AppPlayersAthleteIdRoute
  '/players/new': typeof AppPlayersNewRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/verify-email': typeof VerifyEmailRoute
  '/admin': typeof AppAdminRoute
  '/home': typeof AppHomeRoute
  '/waiver': typeof AppWaiverRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/players/$athleteId': typeof AppPlayersAthleteIdRoute
  '/players/new': typeof AppPlayersNewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/verify-email': typeof VerifyEmailRoute
  '/_app/admin': typeof AppAdminRoute
  '/_app/home': typeof AppHomeRoute
  '/_app/waiver': typeof AppWaiverRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/_app/players/$athleteId': typeof AppPlayersAthleteIdRoute
  '/_app/players/new': typeof AppPlayersNewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/verify-email'
    | '/admin'
    | '/home'
    | '/waiver'
    | '/auth/callback'
    | '/players/$athleteId'
    | '/players/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/verify-email'
    | '/admin'
    | '/home'
    | '/waiver'
    | '/auth/callback'
    | '/players/$athleteId'
    | '/players/new'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/verify-email'
    | '/_app/admin'
    | '/_app/home'
    | '/_app/waiver'
    | '/auth/callback'
    | '/_app/players/$athleteId'
    | '/_app/players/new'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/home': {
      id: '/_app/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AppHomeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/waiver': {
      id: '/_app/waiver'
      path: '/waiver'
      fullPath: '/waiver'
      preLoaderRoute: typeof AppWaiverRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/players/$athleteId': {
      id: '/_app/players/$athleteId'
      path: '/players/$athleteId'
      fullPath: '/players/$athleteId'
      preLoaderRoute: typeof AppPlayersAthleteIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/players/new': {
      id: '/_app/players/new'
      path: '/players/new'
      fullPath: '/players/new'
      preLoaderRoute: typeof AppPlayersNewRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAdminRoute: typeof AppAdminRoute
  AppHomeRoute: typeof AppHomeRoute
  AppWaiverRoute: typeof AppWaiverRoute
  AppPlayersAthleteIdRoute: typeof AppPlayersAthleteIdRoute
  AppPlayersNewRoute: typeof AppPlayersNewRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAdminRoute: AppAdminRoute,
  AppHomeRoute: AppHomeRoute,
  AppWaiverRoute: AppWaiverRoute,
  AppPlayersAthleteIdRoute: AppPlayersAthleteIdRoute,
  AppPlayersNewRoute: AppPlayersNewRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  AuthCallbackRoute: AuthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
